import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);

const initMobileSlider = () => {
  $('.normal-cards').hide();
  
  let width = window.innerWidth;
  console.log('//initMobileSlider', width)

  if (width <= 991){

    $('.swiper-button-prev-ticket').css("display", "flex");
    $('.swiper-button-next-ticket').css("display", "flex");
    $('.swiper-ticket .swiper-initialized .swiper-horizontal .swiper-pointer-events').show();
    $('.swiper-wrapper-ticket').show();
    $('.swiper-ticket').show();
    $('.swiper-wrapper-ticket').show();
    $('.normal-cards').hide();

  }else{

    $('.swiper-button-prev-ticket').hide();
    $('.swiper-button-next-ticket').hide();
    $('.swiper-ticket .swiper-initialized .swiper-horizontal .swiper-pointer-events').hide();
    $('.swiper-button-next-ticket').hide();
    $('.swiper-ticket').hide();
    $('.swiper-wrapper-ticket').hide();
    $('.swiper-wrapper-ticket').hide();
    $('.normal-cards').show();

  }
}

export default () => {

  window.addEventListener('resize', (reportWindowSize) =>{      
      initMobileSlider();
  });

  initContainerSlider('.tech-tickets-list');
  initContainerSlider('.softwares-list');  
  initContainerSlider('.machines-list');    
  initContainerSlider('.slider-container');
  initMobileSlider();
  
}

const initContainerSlider = (container) => {
  document
        .querySelectorAll(`${container}`)
        .forEach((sliderEl) => {
          console.log(`init slider of ${container}`)
            const swiperEl = sliderEl.querySelector('.swiper');
            const nextEL = sliderEl.querySelector('.swiper-button-next');
            const prevEL = sliderEl.querySelector('.swiper-button-prev');
            const swiper = new Swiper(swiperEl, {
                spaceBetween: 26,
                slidesPerView: "auto",
                navigation: {
                    nextEl: nextEL,
                    prevEl: prevEL,
                },
            });

            sliderEl.swiper = swiper
        })

}